import SeoMetaData from "common/SeoMetaData"
import OtpGroupPurchasesPage from "components/GroupPurchases/OtpGroupPurchasesPage"
import {
  GroupPurchasesSteps,
  useGroupPurchasesContext,
} from "components/PurchasePage/GroupPurchasesContext"
import FailBalance from "components/PurchasePage/Preview/Payment/FailedPage"
import Loader from "components/Reusable/Loader"

const Otp = () => {
  const { groupPurchasesSteps } = useGroupPurchasesContext()

  const seo = {
    title: "הזדהות באמצעות קוד אימות - קוד אימות גיפטקארד",
    description: "הזדהות באמצעות קוד אימות - קוד אימות גיפטקארד",
    keywords: "הזדהות, קוד, OTP, קוד אימות",
  }

  return (
    <>
      <SeoMetaData data={seo} />
      {groupPurchasesSteps === GroupPurchasesSteps.FAIL ? (
        <FailBalance
          title="אופסי, משהו השתבש בדרך"
          text="העמוד שחיפשת לא קיים או שיש כרגע בעיה זמנית להגיע אליו"
          link="/groupPurchases"
        />
      ) : groupPurchasesSteps === GroupPurchasesSteps.LOADER ? (
        <Loader />
      ) : (
        <OtpGroupPurchasesPage />
      )}
    </>
  )
}

export default Otp
